module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar', {
    attrs: {
      "tab": "3"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('common-crud', {
    ref: "crud",
    attrs: {
      "searchData": _vm.searchData,
      "tableData": _vm.emailTemplateData,
      "addNewOrEditData": _vm.addNewOrEditData,
      "crudApi": _vm.crudApi,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "editSuccessMessages": "编辑邮件模板成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.emailTemplateData = $event
      },
      "update:table-data": function($event) {
        _vm.emailTemplateData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "templateCode",
      "label": "模板Code",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "templateName",
      "label": "模板标题",
      "min-width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.formatDateTime2Date,
      "sortable": "",
      "prop": "updateTime",
      "label": "操作时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "updateBy",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v("公告信息")]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [_c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板Code",
      "prop": "templateCode"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.addNewOrEditData.templateCode),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "templateCode", $$v)
      },
      expression: "addNewOrEditData.templateCode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "模板标题",
      "prop": "templateName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入模板标题"
    },
    model: {
      value: (_vm.addNewOrEditData.templateName),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "templateName", $$v)
      },
      expression: "addNewOrEditData.templateName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "col-full"
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板标题",
      "prop": "templateContent"
    }
  }, [_c('common-editor', {
    ref: "editor",
    attrs: {
      "editorHeight": "300"
    },
    model: {
      value: (_vm.addNewOrEditData.templateContent),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "templateContent", $$v)
      },
      expression: "addNewOrEditData.templateContent"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存邮件模板？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ac98730", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ac98730","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/sysmanagement/emailtemplate/index.vue
// module id = 1580
// module chunks = 7